<div
  class="fixed bottom-0 max-w-full -mt-6 overflow-hidden trees-footer -z-10"
></div>
